module.exports = __webpack_public_path__ + "static/img/anniversary-btn.874db64.png";